import { ref } from '@vue/composition-api'
import  store  from '@/store'

export default function usePlan() {

  const loading = ref(false)
  const errors = ref({})

  const blank_data = JSON.stringify({
    type: 'containerPest',
    name: '',
    camp_id: null,
    device_id: null,
    camp_leave:'00:00:00',
    camp_back:'00:00:00',
    shift_id: null,
    work_days: [
      "Saturday",
      "Sunday",
      "Monday",
      "Wednesday",
      "Tuesday",
      "Thursday",
      "Friday"
    ],
    areas: [
      {
        id: 1,
        area: null,
        count: 0
      }
    ],
  })

  const form = ref(JSON.parse(blank_data))

  const fetchPlan = id => {
    store.dispatch('plans/fetchPlan', id).then(r => {
      console.log(r)
      Object.assign(form.value, r.data.plan, {
        areas: r.data.plan.data.areas,
        shift_id:r.data.plan.data.shift_id,
        work_days: r.data.plan.data.work_days
      })
      delete form.value.data
    })
  }

  const submit = () =>
     new Promise((resolve, reject) => {
      loading.value = true
      errors.value = {}
      store.dispatch('plans/createPlan', form.value)
        .then(r => {
          form.value = JSON.parse(blank_data)
          resolve(true)
      }).catch(reason => {
          if (reason.response.status === 422){
              errors.value = reason.response.data.errors
          }
        reject(reason.response.data.message)
      }).finally(() => loading.value = false)
    })

  return {
    loading,
    errors,
    form,
    submit,
    fetchPlan
  }
}
